import { render, staticRenderFns } from "./IngredientUnitView.vue?vue&type=template&id=00c4afa2"
import script from "./IngredientUnitView.vue?vue&type=script&lang=js"
export * from "./IngredientUnitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports